export default __webpack_public_path__ + "static/differenza-backend-frontend-fullStack-iceberg-86f4a54af38057ba2b1f75ba183f72f6.jpg";